import React, { Component } from 'react';
import NavigationItems from './Components/NavigationItems';
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'

import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { Modal,ButtonToolbar,Button } from 'react-bootstrap';
import { TextArea } from 'semantic-ui-react';
import {
    Redirect
  } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'; // Import
import validator from 'validator';


class MyVerticallyCenteredModal extends React.Component {
  constructor(){
      super()
      this.state = {
        oldp:"",
        newp:"",
        cp:"",
        validator:true,
        finished:false,
      }
      
  }
  
   submitForm= ()=>{
      // console.log('data ',this.state);
      
      var bodyFormData = new FormData();
      bodyFormData.set('keyword', 'change_pwd');
      bodyFormData.set('username', this.props.username);
      bodyFormData.set('password', this.state.oldp);
      bodyFormData.set('new_password', this.state.cp);

      axios.patch(
          Base.url + 'UserAdditional/',
          bodyFormData,
            {
              headers: {
                  'Authorization': 'Token ' + localStorage.getItem('Token'),
              }
          }
      )
      .then(response =>{
          // console.log('response : ',response);
              if(response.data.Status){
                localStorage.removeItem('Token');
                // alert(response.data.Message+" Please login")
                this.props.onHide()

                confirmAlert({
                  title: 'Password Changed',
                  message: 'Please login again',
                  buttons: [
                    {
                        label: 'ok',
                        onClick: () => {
                         this.setState({
                          finished:true
                        },()=>{
                          this.props.logOut()
                        })
                        }
                    }
                  ]
                });
                // NotificationManager.success("Password Changed", "Login please", 3000);
               
                
              }else{
                  console.log(response.data.Message);
                  // alert(response.data.Message+" : "+response.data.Error)
                  NotificationManager.error(response.data.Error, response.data.Message, 3000);
              }
      })
      .catch(error=>{
          console.log(error);
          NotificationManager.error('Error : ', error, 3000);
      })
      // data.push({'orderid':this.props.id,'details':this.state})
      // this.props.MakeQuotation(data)
      // this.props.onHide()
  }

  onChange=(e)=>{
      this.setState ({
          [e.target.name]:e.target.value
      },()=>{
        if(this.state.newp===this.state.cp){
          this.setState({
            validator:true
          })
        }
        else{
          this.setState({
            validator:false
          })
        }
      })
  }

  render() {
      // console.log('props ',this.props);
      const show= this.props.show
      const onHide = this.props.onHide
      // const {}

      return (
          <Modal
          show={show}
          onHide={onHide}

          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
      >
          <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                  Change Password
      </Modal.Title>
          </Modal.Header>
          <Modal.Body >
              {
              this.state.finished?
              <div>
                <label className="label label-success h2 text-green" >Password changed sucessfully</label>
              </div>
              :
              <>
              <div>
                  Type Old password :
              </div>
              <div>
                  <input name="oldp" value={this.state.name} onChange={this.onChange} type="password" className="form-control" placeholder="Old password"/>
              </div>
              <div>
                  Type New Password :
              </div>
              <div>
                  <input name="newp" value={this.state.name} onChange={this.onChange}  type="password" className="form form-control" placeholder="New password"/>
              </div>
              <div>
                 Confirm New Password :
              </div>
              
              <div>
                  <input name="cp" value={this.state.name} onChange={this.onChange}  type="password" className="form form-control" placeholder="Confirm password" alt="hint"/>
              </div>
              <div>
                {this.state.validator?'':<label className="text text-danger" >Password do not match</label>}
              </div>
              </>
              }

              

          </Modal.Body>
          <Modal.Footer>
              <Button onClick={this.submitForm}>Submit</Button>
          </Modal.Footer>
      </Modal>
      )
  }
}
export default class componentName extends Component {
  constructor(){
    super()
    this.state={
      data : [],
      emailer:[],
      // emailo:'',
     
      changes:false,
      first_name:'',
      email:'',
      username:"",
      
      emailvalidation:true,

      logout:false,

      modalShow:false,
      
    }
  }
  componentDidMount(){
    this.fetchAdminData()
    this.fetchEmailData()
  }
// componentDidMount(){
//   this.fetchEmailData()
// }


  fetchAdminData(){
    axios.get(
      Base.url + 'User/?keyword=get_admin_profile',
      {
        headers:{
          'Authorization': 'Token ' + localStorage.getItem('Token'),
        }
      }
    ).then(response =>{
      // console.log('Response ',response);
      // console.log('Response Data',response.data.results[0].email);
      this.setState({
        data : response.data.results[0],
        first_name:response.data.results[0].first_name,
        // email:response.data.results[0].email,
        username:response.data.results[0].username,
      })
      
      
    }).catch(error =>{
      NotificationManager.error('Error : ', error, 3000)
      
    })

  }
 


  fetchEmailData(){
    // console.log("worked");
    

    axios.get(
      Base.url + 'NotificationEmails/',
      {
        headers:{
          'Authorization': 'Token ' + localStorage.getItem('Token'),
        }
        
      }
    ).then(response =>{
      // console.log('Responseemail ',response.data.results);
      // console.log('ffffffffff',this.emailer[0].email);
      //  console.log('Response Data',response.data.results[0].email);
      this.setState({
          emailer : response.data.results,
      })
    }).catch(error =>{
      NotificationManager.error('Error : ', error, 3000)
    })
  }
  
   
   

  updateAdmin=()=>{

    if(!this.state.emailvalidation){
      NotificationManager.warning("Incorrect email ", 'Warning ', 10000)
      return false
    }
        
    var bodyFormData = new FormData();
    bodyFormData.set('first_name', this.state.first_name);
    bodyFormData.set('email',this.state.email);
    bodyFormData.set('username',this.state.username);
    bodyFormData.set('address', '0');
    bodyFormData.set('mobile', '0');
    bodyFormData.set('name_in_arabic', '0');
    bodyFormData.set('address_in_arabic', '0');

    // console.log(bodyFormData);

    axios.put(
        Base.url + 'User/',
        bodyFormData,
    {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('Token'),
            }
        }
    )
    .then(response =>{
        // console.log('response : ',response);
        this.setState({
          changes:false
        })
          // this.fetchAdminData()
          if(response.data.Status){
            NotificationManager.success( response.data.Message,'Success : ',3000)
          }else{
              console.log(response.data.Message);
              NotificationManager.error('Error : ', response.data.Error, 3000)
          }
          this.fetchAdminData()
    })
    .catch(error=>{
      NotificationManager.error('Error : ', error, 3000)

    })
    
  }
  logout=()=>{
    this.setState({ logout: true })
  }

  emailValidation=(event)=>{
    var email = event.target.value
    // console.log('email ',email);
    // console.log('email validation ',validator.isEmail(email));
    
    
    this.setState({
      email: email,changes:true
    },()=>{
        let result = validator.isEmail(this.state.email); //=> true
        if(!result){
          this.setState({
            emailvalidation:false
          })
        }
        else{
          this.setState({
            emailvalidation:true
          })
        }
        
      }
    )

    
  }
  // Base.url + 'NotificationEmails/?id='+data.id,


   deletemail (id){
    // console.log('Delete  data ',id);
    // alert('Delete  data '+id);
  
    // return false
    axios.delete(
      Base.url + 'NotificationEmails/?id='+id  ,
        {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('Token'),
            }
        }
    )
    .then(response =>{
        // console.log('response : ',response);
          //  alert("deleted")
          this.fetchEmailData()
          NotificationManager.success( response.data.Message,'Success : ',3000)
    })
    .catch(error=>{
        console.log(error);
        NotificationManager.error('Error : ', error, 3000)

    })
}
handleChange =(event)=>{
  this.setState({
   emaildata:event.target.value
  });
console.log(this.state.emaildata);
};

addemail=()=>{
  // alert(this.state.emaildata)
  // console.log("clicked");
  // return false
  if(!this.state.emailvalidation){
    NotificationManager.warning("Incorrect email ", 'Warning ', 10000)
    return false
  }
          
    var bodyFormData = new FormData();
    bodyFormData.set('email', this.state.email);

    axios.post(
        Base.url + 'NotificationEmails/',
        bodyFormData,
        {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('Token'),
            }
        }
    )
    .then(response =>{
        // console.log('response : ',response);

        if(response.data.Status){
          this.fetchEmailData()
          this.setState({
            email:"",
          })
          NotificationManager.success( response.data.Message,'Success : ',3000)

        }else{
          console.log(response.data.Message);
          NotificationManager.error( response.data.Message,'Failed : ',3000)

          // NotificationManager.error('Error : ', response.data.Error, 3000)
        } 

        // NotificationManager.success( response.data.Message,'Success : ',3000)

    })
    .catch(error=>{
        console.log(error);
    })
};
 
  
  
  render() {
    
    const data = this.state.data
    if(this.state.logout){
      return <Redirect to='/login' />
    

      
      
    }
    // console.log('Data ',data);
    // console.log('Data ',data.email);
  
    
    return (
      <div>
{/* <NotificationContainer/> */}

        <NavigationItems />
        {/* Main content */}
        <div className="main-content">
          <PageHeader pageName='Admin Profile' />

          

          <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
              <div className="container-fluid">
                  <div className="header-body">
                      {/* Card stats */}
                      <div className="row">
                          <div className="col-xl-3 col-lg-6">
                          </div>
                          <div className="col-xl-3 col-lg-6">
                          </div>
                          <div className="col-xl-3 col-lg-6">
                          </div>
                          <div className="col-xl-3 col-lg-6">
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          {/* Page content */}
          <div className="container-fluid mt--7">
            <div className="row">

              <div className="col-xl-12 order-xl-1">
                <div className="card bg-secondary shadow">
                  <div className="card-header bg-white border-0">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h3 className="mb-0">My account</h3>
                      </div>
                      <div className="col-4 text-right">
                        {this.state.changes?<button className="btn btn-sm btn-primary" onClick={this.updateAdmin}>Update</button>:''}
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <form>
                      <h6 className="heading-small text-muted mb-4">Hello {data.username} </h6>
                      <div className="pl-lg-4">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="form-control-label" htmlFor="input-username">Username</label>
                              <input type="text" id="input-username" className="form-control form-control-alternative" placeholder="Username" value={this.state.username} onChange={(event) => this.setState({username: event.target.value,changes:true})}  />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="form-control-label" htmlFor="input-username">First name</label>
                              <input type="text" id="input-username" className="form-control form-control-alternative" placeholder="Username" value={this.state.first_name} onChange={(event) => this.setState({first_name: event.target.value,changes:true})}  />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          {/* <div className="col-lg-6">
                            <div className="form-group">
                              <label className="form-control-label" htmlFor="input-username">First name</label>
                              <input type="text" id="input-username" className="form-control form-control-alternative" placeholder="Username" value={this.state.first_name} onChange={(event) => this.setState({first_name: event.target.value,changes:true})}  />
                            </div>
                          </div> */}
                          {/* <div className="col-lg-6">
                            <div className="form-group">
                              <label className="form-control-label" htmlFor="input-email">Email address</label>
                              <input type="email" id="input-email" className="form-control form-control-alternative" placeholder="email" value={this.state.email} onChange={this.emailValidation}  />
                            </div>
                          </div> */}
                        </div>

              
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                            </div>
                          </div>
                          {/* <div className="col-lg-6">
                            <div className="form-group">
                              <label className="form-control-label" htmlFor="input-last-name">Mobile</label>
                              <input type="text" id="input-last-name" className="form-control form-control-alternative" placeholder="Last name" defaultValue={798894654} />
                            </div>
                          </div> */}
                        </div>


                      </div>
                      
                    </form>
                    <MyVerticallyCenteredModal  
                          show={this.state.modalShow}
                          username={this.state.username}
                          logOut={this.logout}
                          onHide={() => this.setState({ modalShow: false })}
                          />
                              <button className="btn btn-primary" onClick={()=>{this.setState({modalShow:true})}}>Change password</button>
                  </div>
                </div>
              </div>
              
            </div>
            <Footer />
            <br></br>
          </div>
          

          {/* nnnnnnnnnnnnnnnnnnnnnext */}


          <div className="container-fluid mt--7">
            <div className="row">

              <div className="col-xl-12 order-xl-1">
                <div className="card bg-secondary shadow">
                  <div className="card-header bg-white border-0">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h3 className="mb-0">Notification Emails</h3>
                      </div>
                            
                      <div className="col-4 text-right">
                        {/* {this.state.changes?<button className="btn btn-sm btn-primary" onClick={this.updateAdmin}>Update</button>:''} */}
                      </div>
                    </div>
                  </div>
       
                  <div className="card-body">
                
                    {/* <form> */}
                      {/* <h6 className="heading-small text-muted mb-4">Hello {data.username} </h6> */}
                      <div className="pl-lg-4">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group" >
                             
                             {/* <label className="form-control-label" htmlFor="input-username">Username</label> */}
                            
                             <table  >
                               <tbody>
                                    <tr >
                                      <td colSpan="1">
                                      <input type="email" id="input-email" className="form-control form-control-alternative" size="70" placeholder="email" value={this.state.email} onChange={this.emailValidation}  />
                                      
                                      </td>
                                      <td colSpan="3">
                                    
                                      <button  className="ml-2 btn btn-sm btn-success" onClick={this.addemail} >
                                        <i className="fa fa-plus" style={{fontsize:"24px",}}></i>
                                      </button>
                                
                                      </td>
                                  </tr>
                                </tbody>
                              </table><br></br>

                               {this.state.emailer.length>0&&this.state.emailer.map((item,index)=>{
                                return<div className="form-group" key={index}>
              
                                <table>
                                  <tbody>
                                    <tr>
                                        <td colSpan="1">
                                        <input disabled name="mobile" value={item.email} size="70" className="form-control form-control-alternative"   />
                                        </td>
                                        <td colSpan="3">
                                        <button  className="ml-2 btn btn-sm btn-danger " onClick={()=>this.deletemail(item.id)} >
                                        <i className="fas fa-trash"></i>
                                        </button>
                                        </td>
                                    </tr>
                                  </tbody>
                                    
                                </table>
                                </div>
                                
                                })
                              } 

           
                            </div>
                            
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-6">
                            {/* <div className="form-group">
                              <label className="form-control-label" htmlFor="input-username">First name</label>
                              <input type="text" id="input-username" className="form-control form-control-alternative" placeholder="Username" value={this.state.first_name} onChange={(event) => this.setState({first_name: event.target.value,changes:true})}  />
                            </div> */}
                          </div>
                          {/* <div className="col-lg-6">
                            <div className="form-group">
                              <label className="form-control-label" htmlFor="input-email">Email address</label>
                              <input type="email" id="input-email" className="form-control form-control-alternative" placeholder="email" value={this.state.email} onChange={this.emailValidation}  />
                            </div>
                          </div> */}
                        </div>
                        

                        {/* <div className="row">
                          <div className="col-lg-6">
                            <div className="">
                            </div>
                          </div>

                        </div> */}

                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                            </div>
                          </div>
                          {/* <div className="col-lg-6">
                            <div className="form-group">
                              <label className="form-control-label" htmlFor="input-last-name">Mobile</label>
                              <input type="text" id="input-last-name" className="form-control form-control-alternative" placeholder="Last name" defaultValue={798894654} />
                            </div>
                          </div> */}
                        </div>


                      </div>
                      
                    {/* </form> */}
                    <MyVerticallyCenteredModal
                          show={this.state.modalShow}
                          username={this.state.username}
                          logOut={this.logout}
                          onHide={() => this.setState({ modalShow: false })}
                          />
                              {/* <button className="btn btn-primary" onClick={()=>{this.setState({modalShow:true})}}>Change password</button> */}
                  </div>
                </div>
              </div>
              
            </div>
            <Footer />
          </div>
        </div>
      </div>

    );
  }
}
